import { ReactNode } from 'react'
import styled from 'styled-components'

export const TextCell = ({ children }: { children: ReactNode }) => <Text>{children}</Text>

export const MutedCell = ({ children }: { children: ReactNode }) => <Muted>{children}</Muted>

const Text = styled.span`
  color: ${({ theme }) => theme.colors.ink2};
`

const Muted = styled.span`
  color: ${({ theme }) => theme.colors.ink3};
`
